var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"d-flex align-items-center justify-content-between m-0"},[_c('span',[_vm._v("Design Studio v2")]),_c('b-form-checkbox',{staticClass:"ml-3 mb-0",attrs:{"switch":"","checked":_vm.ds2,"disabled":_vm.toggling},on:{"change":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }